import cookie from '../cookie'

const experienceName = 'AB-3543'

export async function getOptionalEmailVerificationEnabled(): Promise<boolean> {
  try {
    const overrideCookie = cookie.getCookie('x-feature-optional-ev')
    if (overrideCookie) return overrideCookie === 'true' || overrideCookie === '1'
    const { MONETATE_CHANNEL: channel } = window.auth
    const monetateId = cookie.getCookie('mt.v')
    const res = await fetch('https://engine.monetate.net/api/engine/v1/decide/JohnLewis', {
      method: 'POST',
      credentials: 'omit',
      body: JSON.stringify({
        channel,
        monetateId,
        events: [
          {
            eventType: 'monetate:decision:DecisionRequest',
            requestId: '1',
            includeReporting: true,
          },
          {
            eventType: 'monetate:context:PageView',
            url: document.location.href,
          },
        ],
      }),
    })
    const json = await res.json()
    const experiment = json.data.responses[0].actions.filter((action: any) =>
      action.impressionReporting[0].experience_name.includes(experienceName),
    )[0]
    const optionalEVEnabled = experiment && !experiment.isControl
    return optionalEVEnabled
  } catch (_error) {
    return false
  }
}
